// ============================================================================
// Full screen for the note / report editor windows
// ============================================================================
// A toggle that lets the editor fill the browser window (and back). The
// choice is remembered per user, shared by the note and report editors.

import React, { useCallback, useState } from 'react';

const KEY = 'fsa.docEditor.fullscreen';

/** Style to merge into `.modal-container` while full screen (it is centred with a transform). */
export const FULLSCREEN_STYLE: React.CSSProperties = {
  top: 0, left: 0, transform: 'none',
  width: '100vw', height: '100vh', maxWidth: '100vw', maxHeight: '100vh', borderRadius: 0,
};

export function useModalFullscreen(): [boolean, () => void] {
  const [full, setFull] = useState<boolean>(() => {
    try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
  });
  const toggle = useCallback(() => {
    setFull(f => {
      try { localStorage.setItem(KEY, f ? '0' : '1'); } catch { /* storage unavailable */ }
      return !f;
    });
  }, []);
  return [full, toggle];
}

/** Header button — corners out (enter) / corners in (exit). */
export const FullscreenButton: React.FC<{ full: boolean; onToggle: () => void; disabled?: boolean }> = ({ full, onToggle, disabled }) => (
  <button
    type="button"
    className="modal-header-btn"
    onClick={onToggle}
    disabled={disabled}
    title={full ? 'Exit full screen' : 'Full screen'}
    aria-label={full ? 'Exit full screen' : 'Full screen'}
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={full ? 'M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5' : 'M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5'} />
    </svg>
  </button>
);
